import React from 'react';

import classes from './FareRulesItem.scss';

const fareRulesItem = (props) => (
    <div className={classes.Item}>
        { props.type ? <div className={[classes.ItemPrimary, props.isDomRT ? classes.ItemPrimarySmall : null, props.fullWidth ? classes.ItemPrimaryFullWidth : null].join(' ')}>{props.type}</div> : null }
        { props.amount ? <div className={[classes.ItemSecondary, props.isDomRT ? classes.ItemSecondarySmall : null].join(' ')}>{props.amount}</div> : null }
    </div>
);

export default fareRulesItem;


// WEBPACK FOOTER //
// ./src/components/Flight/Tuple/TupleInner/FareInfo/FareRules/FareRulesItem/FareRulesItem.js